
























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Card, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import Callout from '@/components/Callout.vue';

// gql
import copyDocumentMutation from '@/graphql/mutations/document/Copy.gql';
import createDocumentMutation from '@/graphql/mutations/document/Create.gql';
import deleteDocumentMutation from '@/graphql/mutations/document/Delete.gql';
import fetchShipmentDocuments from '@/graphql/queries/document/List.gql';

// types
import { documentTypeOptions } from '@/constants/documentTypeOptions.ts';
import { DocumentTypeEnum, ShipmentDocumentFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    documents: {
      query: fetchShipmentDocuments,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          shipmentId: this.$route.params.id
        };
      },
      update(data) {
        return data?.shipmentDocuments || [];
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  },
  components: {
    Callout,
    'el-button': Button,
    'el-card': Card,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu
  }
})

export default class DocumentLists extends Vue {
  private documents: ShipmentDocumentFields[] = [];
  private readonly documentTypeOptions = documentTypeOptions();

  private async createDocument(documentType: DocumentTypeEnum) {
    try {
      const response = await this.$apollo.mutate({
        mutation: createDocumentMutation,
        variables: {
          documentType: documentType,
          shipmentId: this.$route.params.id
        }
      });

      if (response) {
        this.$apollo.queries.documents.refetch();

        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.created'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }

  private async copyDocument(id: string) {
    try {
      const response = await this.$apollo.mutate({
        mutation: copyDocumentMutation,
        variables: {
          shipmentDocumentId: id
        }
      });

      if (response) {
        this.$apollo.queries.documents.refetch();

        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.added'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }

  private editDocument(id: string) {
    this.$router.push({
      name: 'shipmentDocumentForm',
      params: { id: this.$route.params.id, document_id: id }
    });
  }

  private async deleteDocument(id: string) {
    try {
      const response = await this.$apollo.mutate({
        mutation: deleteDocumentMutation,
        variables: {
          shipmentDocumentId: id
        }
      });

      if (response) {
        this.$apollo.queries.documents.refetch();

        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.deleted'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }

  private getUserToken() {
    let token = '';
    const tokenName = 'X-Auth-Token';
    document.cookie.split(';').forEach((i) => {
      const pair = i.split('=');
      if (pair[0].trim() === tokenName) {
        token = pair[1];
      }
    });
    return token;
  }

  private url(document: ShipmentDocumentFields) {
    return `${document?.url}?preview=true&token=${this.getUserToken()}&role=operator`;
  }
}
